import axios from 'axios';
import querystring from 'querystring';
import Class from '../utils/class/main';

export default class requestAccount {
  static async companiePost(dataCompanie) {
    return axios.all([
      axios.post(`${process.env.VUE_APP_URL_API}/companie`,
        querystring.stringify(dataCompanie)),
    ])
      .then(axios.spread((resCompanie) => resCompanie.data.data))
      .catch((error) => {
        Class.requestClass.responseError(error);
      });
  }
}
